export default "__VITE_ASSET__Bdwq5Gue__"